<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.program.contactList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>{{$t('form.program.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.program.programCode')}}</label>
                                    <v-select @input="searchPrograms" :options="programCodes" v-model="search.code"
                                        :reduce="programCodes => programCodes">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.program.programType')}}</label>
                                    <v-select @input="searchPrograms" :options="programTypes" v-model="search.type"
                                        :reduce="programTypes => programTypes">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.program.programTitle')}}</label>
                                    <v-select @input="searchPrograms" :options="programTitles" v-model="search.title"
                                        :reduce="programTitles => programTitles">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.program.academicYear')}}</label>
                                    <v-select @input="searchPrograms" :options="programYears" v-model="search.year"
                                        :reduce="programYears => programYears">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="detailedSearch">
                            <div class="col-12">
                                <hr>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('form.program.presetName')">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.program.contactList')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="programs.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.program.academicYear')}}</th>
                                    <th>{{$t('form.program.programType')}}</th>
                                    <th>{{$t('form.program.programTitle')}}</th>
                                    <th>{{$t('form.program.programCode')}}</th>
                                    <th class="text-right">{{$t('form.program.printBatch')}}</th>
                                    <th class="text-right">{{$t('form.program.showContacts')}}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(student, index) in programs" v-bind:key="index"
                                    @dblclick="goToShow(student.ID)">
                                    <td>{{student.AcademicYear | formatDate('YYYY')}}</td>
                                    <td>{{student.ProgramType }}</td>
                                    <td>{{student.ProgramTitle}}</td>
                                    <td>{{student.ProgramCode}}</td>
                                    <td class="text-right">
                                        <button class="btn btn-danger btn-sm" @click="generatePdf(student.ID)">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            {{$t('button.pdf')}}
                                        </button>
                                    </td>
                                    <td class="text-right">
                                        <button v-if="permissions.viewStudentsContacts" @click="goToShow(student.ID)"
                                            class="btn btn-info btn-sm">
                                            <i class="fa fa-users"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                detailedSearch: false,
                presetSelected: false,

                pagination: {
                    current_page: 1
                },

                search: {},
                preset: {
                    name: '',
                    entity: null,
                    value: {}
                },

                programCodes: [],
                programTypes: [],
                programTitles: [],
                programYears: [],

                programs: [],
                presetList: [],

                entity:null,
            }
        },

        async mounted() {
            this.isLoading = true;

            if (!this.permissions.viewStudentsContacts) {
                this.$router.push('/');
                return;
            }

            await this.getInitialData();
            if(this.$route.path=='/student/contact/list'){
                this.entity = 'student';
            }else if(this.$route.path=='/alumni/contact/list'){
                this.entity = 'alumni';
            }
            if(this.entity=='student'){
                if (localStorage.getItem('filter-student-contact')) {
                  this.search = JSON.parse(localStorage.getItem('filter-student-contact'));

            }
            }else if(this.entity=='alumni'){
                if (localStorage.getItem('filter-alumni-contact')) {
                  this.search = JSON.parse(localStorage.getItem('filter-alumni-contact'));
                }            
            }

            this.getPrograms();
            this.getPresets();
        },

        watch: {
            search: {
                handler() {
                    if(this.entity=='student'){
                   localStorage.setItem('filter-student-contact', JSON.stringify(this.search));
                    }else if(this.entity=='alumni'){
                    localStorage.setItem('filter-alumni-contact', JSON.stringify(this.search));

                    }

                },
                deep: true
            },
        },
       
       beforeRouteEnter (to, from, next) {
        next(vm => {
           if(from.path!='/' && (from.path=="/student/contact/list" || from.path=="/alumni/contact/list")){
               vm.isLoading = true;
            if(to.path=='/student/contact/list'){
                if (!vm.permissions.viewStudentsContacts) {
                vm.$router.push('/');
                return;
            }
            vm.entity = 'student';
            }else if(to.path=='/alumni/contact/list'){
                if (!vm.permissions.viewAlumniContacts) {
                vm.$router.push('/');
                return;
             }
            vm.entity = 'alumni';
            }
            
            vm.getInitialData();

            if(vm.entity=='student'){
                if (localStorage.getItem('filter-student-contact')) {
                  vm.search = JSON.parse(localStorage.getItem('filter-student-contact'));
                }
            }else if(vm.entity=='alumni'){
                if (localStorage.getItem('filter-alumni-contact')) {
                  vm.search = JSON.parse(localStorage.getItem('filter-alumni-contact'));
                }            
            }
            
            vm.preset.name = '';
            vm.preset.value = {};
            vm.preset.entity = null;
            vm.presetSelected = false;

            vm.getPrograms();
            vm.getPresets();
           }
        })
        },

        methods: {
            async getInitialData() {
                let response = await axios.get('/api/programs/initial-data');
                
                if (response.data) {
                    let data = response.data;

                    this.programCodes = data.program_codes;
                    this.programTypes = data.program_types;
                    this.programTitles = data.program_titles;
                    this.programYears = data.program_years;
                }
            },

            getPrograms() {
                let source = axios.CancelToken.source();

                if (this.request_source != '') {
                    this.request_source.cancel('Operation canceled by the user.');
                    console.clear();
                }

                this.request_source = source;

                this.isLoading = true;
                if(this.$route.path=='/alumni/contact/list'){
                    this.entity = 'alumni'
                }else if(this.$route.path=='/student/contact/list'){
                    this.entity = 'student'
                }
                axios
                    .get('/api/programs?contact&page=' + this.pagination.current_page+'&entity='+this.entity, {
                        params: this.search,
                        entity:'alumni'
                    })
                    .then(response => {
                        this.isLoading = false;

                        this.programs = response.data.data.data;
                        this.pagination = response.data.pagination;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getPrograms();
            },

            searchPrograms() {
                this.pagination.current_page = 1;
                this.getPrograms();
            },

            clearSearch() {
                this.search = {};
                this.searchPrograms();
            },

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {type});
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async generatePdf(id) {
                let token = await this.createToken('contacts-export');
                if (token == '') return;

                window.open(`/transcripts/program/${id}/pdf?token=${token}&entity=${this.entity}`, '_blank');
            },

            goToShow(id) {
                if (!this.permissions.viewStudentsContacts) return;
                if(this.$route.path.includes('alumni/')){
                    this.$router.push({
                    name: 'AlumniContactShow',
                    params: {
                        id: id
                    }
                });
                }else if(this.$route.path.includes('student/')){
                    this.$router.push({
                    name: 'StudentContactShow',
                    params: {
                        id: id
                    }
                });
                }
                
            },

            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);
                this.preset.entity = this.entity +'_contact';
                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            getPresets() {
                axios
                    .get('/api/presets/?entity='+this.entity +'_contact')
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: this.entity+'_'+'contact'
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchPrograms();
            },

            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.clearSearch();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.preset.entity = null
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
